'use client'

import { Button } from '@/shared/ui/button'
import { cn } from '@/utils/cn'
import Link from 'next/link'
import { HTMLAttributes } from 'react'
import { useAlarmTooltipShow } from '../../hooks/use-alarm-tooltip-show'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/shared/ui/tooltip'
import { useGAPurchase } from '../../hooks/use-ga-purchase'
import { useProductDetailFooter } from './use-product-detail-footer'
import { NotificationButton } from '@/shared/ui/notification-button'
export interface ProductDetailFooterProps
  extends HTMLAttributes<HTMLDivElement> {
  productId: string
}

export const ProductDetailFooter = ({
  productId,
  className,
  ...props
}: ProductDetailFooterProps) => {
  const { show } = useAlarmTooltipShow()
  const { gaPurchase } = useGAPurchase({ productId })
  const { data: productDetailFooter, pending } = useProductDetailFooter({
    productId,
  })

  if (pending) return null
  if (!productDetailFooter) return null

  const { price, priceLowest, linkUrl, notificationId } = productDetailFooter

  return (
    <footer
      className={cn(className, 'flex items-center gap-4 px-5 pb-5 pt-2')}
      {...props}
    >
      <TooltipProvider>
        <Tooltip open={show && !notificationId}>
          <TooltipTrigger>
            <NotificationButton.Image
              id={productId}
              price={price}
              priceLowest={priceLowest}
            />
          </TooltipTrigger>
          <Button
            className="h-[60px] w-full text-body-01-semi text-white"
            variant="primary"
            asChild
          >
            <Link href={linkUrl} target="_blank" onClick={gaPurchase}>
              쿠팡에서 구매하기
            </Link>
          </Button>
          <TooltipContent align="start">
            알림을 설정하고 최저가로 상품을 구매해보세요!
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </footer>
  )
}
